import WebsiteModal from "./WebsiteModal";

export default class ManagementTeamModal extends WebsiteModal {

    constructor(data) {
        super();
        this.data = data;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__overlay js-close"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "modal__close-btn js-close-modal"}),
                    eotwJSXFactory('div', {className: "staff-info"}, [
                        eotwJSXFactory('div', {className: "staff-info__heading"}, [
                            'undefined' !== typeof this.data.image ? (eotwJSXFactory('div', {className: "staff-info__image", unsafeHtml: this.data.image})) : '',
                            eotwJSXFactory('div', {className: "staff-info__text"}, [
                                'undefined' !== typeof this.data.name ? (eotwJSXFactory('h2', {className: 'heading heading--3'}, [this.data.name])) : '',
                                'undefined' !== typeof this.data.role ? (eotwJSXFactory('h3', {className: 'heading heading--5'}, [this.data.role])) : ''
                            ])
                        ]),
                            'undefined' !== typeof this.data.content ? (eotwJSXFactory('div', {className: "staff-info__content", unsafeHtml: this.data.content})) : ''
                    ])
                ])
            ])
        );
    }
}
